/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  accountBalancesListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGet,
} from "../../funcs/accountBalancesListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGetRequest$inboundSchema,
};

export const tool$accountBalancesListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGet:
  ToolDefinition<typeof args> = {
    name: "account-balances-history-v1",
    description: `Original tool name: account-balances-list-account-balances-api-v1-ledgers-ledger-canister-id-accounts-account-id-balance-history-get

List daily transaction balances for an account

This endpoint returns an account's daily balances.

### How is data retrieved for this endpoint?

Values from the endpoint are created by scraping the transactions from the
ledger canister (and associated archive canisters).`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountBalancesListAccountBalancesApiV1LedgersLedgerCanisterIdAccountsAccountIdBalanceHistoryGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };